module.exports = __webpack_public_path__ + "img/hotel-7a.3a075690.jpeg";